import { CustomizationThemeDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';
import { Box } from '@mui/material';
import { IconLibrary } from '@act/storybook';

export const CustomizationThemeTableColumns =
  (): ColumnConfiguration<CustomizationThemeDto>[] => [
    {
      id: 'name',
      value: 'name',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Name',
      noWrap: true,
    },
    {
      id: 'description',
      value: 'description',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Description',
      noWrap: true,
    },
    {
      id: 'category',
      value: 'category',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Category',
      noWrap: true,
    },
    {
      id: 'logoGradientColors',
      value: theme => (
        <Box
          sx={{
            width: '100%',
            height: 30,
            background: `linear-gradient(135deg, ${theme.logoGradientColors.join(
              ', '
            )})`,
            borderRadius: 1,
            border: '1px solid #e0e0e0',
          }}
        />
      ),
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: false,
      title: 'Logo Gradient',
    },
    {
      id: 'accentGradientColors',
      value: theme => (
        <Box
          sx={{
            width: '100%',
            height: 30,
            background: `linear-gradient(135deg, ${theme.accentGradientColors.join(
              ', '
            )})`,
            borderRadius: 1,
            border: '1px solid #e0e0e0',
          }}
        />
      ),
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: false,
      title: 'Accent Gradient',
    },
    {
      id: 'deletedAt',
      value: theme =>
        theme.deletedAt ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <IconLibrary iconName="X" size={26} color="error" weight="bold" />
          </Box>
        ) : null,
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Deleted',
      align: 'center',
    },
  ];
